import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";

import Header from "./Header";
import Footer from "./Footer";
import WhatsAppWidget from "@/components/common/WhatsAppWidget";
import CookieBanner from "@/components/common/CookieBanner";
import Seo from "@/components/seo/Seo";
import { PUBLIC_SEO } from "@/lib/public-seo";

const PREFIX_NOINDEX: Array<{ prefix: string; title: string; description: string }> = [
  {
    prefix: "/odeme/",
    title: "Ödeme | Mersa Akademi",
    description: "Mersa Akademi güvenli ödeme sayfası.",
  },
  {
    prefix: "/sifre-sifirla/",
    title: "Şifre Sıfırla | Mersa Akademi",
    description: "Mersa Akademi hesap şifresi sıfırlama.",
  },
  {
    prefix: "/eposta-dogrula/",
    title: "E-posta Doğrulama | Mersa Akademi",
    description: "Mersa Akademi e-posta doğrulama.",
  },
];

export default function PublicLayout() {
  const location = useLocation();
  const staticSeo = PUBLIC_SEO[location.pathname];
  const prefixSeo = PREFIX_NOINDEX.find((p) => location.pathname.startsWith(p.prefix));
  const seo = staticSeo
    ? { ...staticSeo, path: location.pathname }
    : prefixSeo
      ? { ...prefixSeo, path: location.pathname, noindex: true as const }
      : null;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen flex-col overflow-x-clip">
      {seo && (
        <Seo
          title={seo.title}
          description={seo.description}
          path={seo.path}
          noindex={Boolean("noindex" in seo && seo.noindex)}
        />
      )}
      <Header />
      {/* min-w-0 sadece içerik alanında: header logo/nav sıkışmasın */}
      <main className="min-w-0 max-w-full flex-1 overflow-x-clip">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppWidget />
      <CookieBanner />
    </div>
  );
}
